import TableRow from '@/components/TableRow/TableRow';

export default TableRow;
